import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { Stack, styled } from '@mui/system';
import { ReactComponent as HfsLogo } from './logo-blink.svg';
import { Typography } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const BlinkingLogo = styled(HfsLogo)({
  width: '150px',
  animation: 'blink 1.5s infinite',
  '@keyframes blink': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
});

const theme = createTheme({
  typography: {
    body1: {
      fontSize: '1rem',
      fontWeight: 600,
      color: '#4cadc5',
      fontStyle: 'italic',
    },
  },
});

interface LoadingBackdropProps {
  open: boolean;
}

/*
  * LoadingBackdrop component
  * @param {boolean} open - open state of the backdrop
  * @returns {JSX.Element} - LoadingBackdrop component
  * @exports LoadingBackdrop
  * @version 1.0.0
  * @since 1.0.0
  * Timeout is defined on Map.tsx line 485, loadfeatures function.
*/

const LoadingBackdrop: React.FC<LoadingBackdropProps> = (props) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      open={props.open}
    >
      <Stack direction="column" spacing={0}
        sx={{
          margin: 0,
          padding: 0,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ThemeProvider theme={theme}>
          <Typography>HFS-APP V{process.env.REACT_APP_VERSION}
          </Typography>
        </ThemeProvider>
        <BlinkingLogo />
        <CircularProgress color="inherit" />
      </Stack>

    </Backdrop>
  );
};

export default LoadingBackdrop;